import React, { useEffect } from 'react';
import { BlueTick } from 'src/assets/images';
import TealiumEvents from 'src/helpers/tealium-events';

type BankingDetailsOTPSuccessProps = {
  onClick: () => void;
};

const BankingDetailsOTPSuccess = ({ onClick }: BankingDetailsOTPSuccessProps) => {
  useEffect(() => TealiumEvents.receivedBankingDetailsUpdateModal, []);
  return (
    <>
      <img src={BlueTick} alt="blue tick" />
      <h1 className="text-4xl text-center text-grey-600">We've received your update request.</h1>
      <p className="w-full max-w-lg text-xl text-center text-grey-400">
        We'll send you an email once the details <br /> have been updated
      </p>
      <button
        type="button"
        className="w-full max-w-sm text-white bg-red-500 h-11 rounded-40"
        onClick={onClick}
      >
        Exit
      </button>
    </>
  );
};

export default BankingDetailsOTPSuccess;
